import {getState} from '../slices/mwDevice';
import objUtils from '../../utils/objUtils';
import firmwareStatusTypes from '../../consts/device/firmwareStatusTypes';

const selectMwDevice = () => getState();

const selectMwDeviceInternalId = () => selectMwDevice().deviceSerialNumber;

const selectIsHolderConnected = () => selectMwDevice().isHolderConnected;

const selectFirmwareState = () => objUtils.returnEmptyObjectIfUndefined(selectMwDevice()?.firmware);

// const selectIsFirmwareStarted = () => {
//     const firmwareState = selectFirmwareState();

//     return firmwareStatusTypes.isStarted(firmwareState);
// };

// const selectMwDeviceIsIdentified = createSelector(selectMwDevice, (globalState) => globalState.isIdentified);

// const selectMwDeviceIsDisconnectedWithNoReconnect = createSelector(
//     selectMwDevice,
//     (globalState) => globalState.isDisconnectedWithNoReconnect
// );

// const selectMwDeviceFirmwareData = createSelector(selectMwDevice, (globalState) => globalState.firmwareData);

export {
    // selectMwDeviceFirmwareData,
    selectMwDeviceInternalId,
    selectIsHolderConnected,
    // selectIsFirmwareStarted,
    // selectMwDeviceIsDisconnectedWithNoReconnect,
    // selectMwDeviceIsIdentified,
};
